import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {
  MatFormFieldModule, MatInputModule, MatSelectModule, MatAutocompleteModule, MatRadioModule,
  MatSlideToggleModule, MatButtonModule, MatCheckboxModule, MatDatepickerModule
} from '@angular/material';
import {FlexLayoutModule} from '@angular/flex-layout';
import {TextMaskModule} from 'angular2-text-mask';
import {FormularioDinamico2Component} from './formulario-dinamico2.component';
import {CampoDinamico2Directive} from './campo-dinamico2/campo-dinamico2.directive';
import {FormInputComponent} from './form-input/form-input.component';
import {FormSelectComponent} from './form-select/form-select.component';
import {FormButtonComponent} from './form-button/form-button.component';
import {FormTextareaComponent} from './form-textarea/form-textarea.component';
import {FormRadioButtonsComponent} from './form-radio-buttons/form-radio-buttons.component';
import {FormCheckboxesComponent} from './form-checkboxes/form-checkboxes.component';
import {FormSwitchComponent} from './form-switch/form-switch.component';
import {FormAutocompleteComponent} from './form-autocomplete/form-autocomplete.component';
import {FormDatePickerComponent} from './form-datepicker/form-datepicker.component';
import {FormKeyValueComponent} from './form-key-value/form-key-value.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TextMaskModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatDatepickerModule
  ],
  declarations: [
    FormularioDinamico2Component, CampoDinamico2Directive,

    FormInputComponent, FormSelectComponent,
    FormTextareaComponent, FormRadioButtonsComponent, FormCheckboxesComponent,
    FormSwitchComponent, FormButtonComponent, FormAutocompleteComponent,
    FormDatePickerComponent, FormKeyValueComponent
  ],
  exports: [FormularioDinamico2Component],
  schemas: [NO_ERRORS_SCHEMA],
  entryComponents: [
    FormInputComponent,
    FormTextareaComponent,
    FormSelectComponent,
    FormAutocompleteComponent,
    FormRadioButtonsComponent,
    FormCheckboxesComponent,
    FormButtonComponent,
    FormSwitchComponent,
    FormDatePickerComponent,
    FormKeyValueComponent
  ]
})
export class FormularioDinamico2Module {
}
